import React from "react";

// /document-api?i=api-usage-flow
export default function ApiUsageFlow() {
  return (
    <>
              <p>
                Once you have completed the <b>API Certificate setup</b>, you
                can start using the API following these steps:
              </p>
              <h5 className="fw-bold">1. Authentication</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">auth</p>
              </div>
              <p>
                Used to request an <b>Access Token</b> to use other APIs.
              </p>
              <ul>
                <li>
                  The token is valid for <b>30 minutes.</b>
                </li>
                <li>
                  Developers must store this token for subsequent API calls.
                </li>
              </ul>

              <h5 className="fw-bold">2. Bank Information</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">get bank</p>
              </div>
              <p>
                Used to retrieve the list of banks supported by SwiftGoldPay.
              </p>
              <ul>
                <li>
                  The <b>Bank Code</b> obtained is required when creating a new
                  customer.
                </li>
              </ul>

              <h5 className="fw-bold">3. Customer Management</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">create customer</p>
              </div>
              <p>
                Used to create a new customer (must be done before financial
                transactions).
              </p>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">get customer</p>
              </div>
              <p>
                Used to retrieve all customers linked to the Broker account.
              </p>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">update customer</p>
              </div>
              <p>Used to update existing customer information.</p>

              <h5 className="fw-bold">4. Deposit</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">deposits Thai</p>
              </div>
              <p>Used for depositing THB (Thai Baht).</p>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">deposits Laos</p>
              </div>
              <p>Used for depositing LAK (Lao Kip).</p>

              <h5 className="fw-bold">5. Withdraw</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">withdraws Thai</p>
              </div>
              <p>Used for withdrawing THB (Thai Baht).</p>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">withdraws Laos</p>
              </div>
              <p>Used for withdrawing LAK (Lao Kip).</p>
              <div className="fw-bold mb-2">📝 Notes:</div>
              <p>
                Whenever a deposit or withdrawal reaches a final status
                (success, cancel, mismatch or refund), the system
                automatically sends a callback to the <b>Callback URL</b>{" "}
                specified by the Broker. Deposit and withdrawal callback URLs
                are configured separately.
              </p>
              <hr/>
<h5 className="fw-bold">Transaction Management (Optionals)</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">get transaction</p>
              </div>
              <p>
                Used to retrieve all past transactions. Please note that this data is <b>not real-time</b>.
              </p>

              <h5 className="fw-bold">Wallet (Optionals)</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">get wallet</p>
              </div>
              <p>
                Used to check the <b>balance</b> in the Broker account.
              </p>

              <h5 className="fw-bold">Refund (Optionals)</h5>
              <div className="d-flex">
                <b className="me-2">Endpoint:</b>
                <p className="text-primary">refund mismatch</p>
              </div>
              <p>
                Used to process a refund for a customer. You can only issue a
                refund for transactions with the status <b>"mismatch"</b>, and
                the refund amount must be <b>equal to or less than</b> the
                original deposited amount.
              </p>
    </>
  );
}
